import { Link, useNavigate, useLocation } from 'react-router-dom'; //Cambio #1 useLocation
import AccountModal from '@jwp/ott-ui-react/src/containers/AccountModal/AccountModal';
import Footer from '@jwp/ott-ui-react/src/components/Footer/Footer';
import styles from './Landing.module.scss';
//Importantes para llevar a Home
import { useAccountStore } from '@jwp/ott-common/src/stores/accountStore';
import { useEffect } from 'react';


export default function Landing() {

  const navigate = useNavigate();
  const location = useLocation(); //Cambio 2

  // Para llevar a Home despues de autentificarse como usuario
  const { user } = useAccountStore();

  useEffect(() => {
  // Solo redirige a Home si NO estamos en un flujo del modal
  if (user && !location.search.includes('u=')) {
    navigate('/');
  }
}, [user, navigate, location]);

  //useEffect(() => {
  //  if (user) {
  //    navigate('/');
  //  }
  //}, [user, navigate]);

  const openLogin = () => {
    navigate('/login?u=login');
  };

  const openRegister = () => {
    navigate('/login?u=create-account');
  };

  return (
    <div className={styles.landing}>
      <div className={styles.overlay} />

      <div className={styles.content}>
        <div className={styles.left}>
          <img
            src="/images/logo_umbra2.png"
            alt="Umbra Stream"
            className={styles.logo}
          />
        </div>

        <div className={styles.right}>
          <div className={styles.formBox}>
            <h2>Iniciar sesión</h2>

            {/* Button Login */}
            <button
              type="button"
              className={styles.loginBtn}
              onClick={openLogin}
            >
              Ingresar
            </button>

            {/* Forgot Password */}
            <div className={styles.actionWrap}>
              <button
                type="button"
                onClick={() => navigate('/login?u=forgot-password')}
                className={styles.secondaryBtn}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>

            {/* Registration */}
            <div className={styles.registerBlock}>
              <p className={styles.register}>
                ¿No tienes cuenta?
              </p>

              <button
                type="button"
                onClick={openRegister}
                className={styles.loginBtn}
              >
                Abre el umbral
              </button>
              <p className={styles.registerLegend}>
                Activa tu acceso sin costo y comienza a explorar.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* Carousel */}
      <div className={styles.carousel}>
        <div className={styles.carouselTrack}>
          {[...Array(2)].map((_, loopIndex) => (
            <div key={loopIndex} style={{ display: 'contents' }}>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/POOL_STILL.png" alt="Pool" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/MAD_GOD_STILL.png" alt="Mad God" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/GLORIOUS_STILL.png" alt="Glorious" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images//carousel/SADNESS_STILL.png" alt="Sadness" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/SHE_WILL_STILL.png" alt="She Will" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/TEXAS_STILL.png" alt="Texas" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/WE_ARE_STILL_HERE_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/LIVING_DEAD_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/HENRY_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/HELLBENDER_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/DRAGULA_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/DEATHGASM_STILL.png" alt="We Are Still Here" />
              </div>
              <div className={styles.carouselItem}>
                <img src="/images/carousel/CHOPPING_MALL_STILL.png" alt="We Are Still Here" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer text="© Versatile Communications 2025" />
      
      {/* Aqui se incluye el MODAL JWP */}
      <AccountModal />

    </div>
  );
}